import React, { FC } from 'react';
import { WCircularProgress, WStack, WTypography } from '../../wrappers/wrapper';
import styles from './notification-tab.module.scss';
import ProfilePhoto from '../../molecules/profile-photo/profile-photo';
import { NOTIFICATION_TYPES } from '../../../utils/constants';
import { TArticle, TComment, TNotification, TUser } from '../../../models/common';
import InfiniteScroll from 'react-infinite-scroll-component';
import useDeviceType from 'custom-hooks/useDeviceType';

interface NotificationTabProps {
  loading: boolean;
  notifications: TNotification[];
  hasMore: boolean;
  fetchData: () => void;
  onClickProfile: (id: string) => void;
  onClick: (notification: TNotification) => void;
}

const NotificationTab: FC<NotificationTabProps> = ({
  loading,
  notifications,
  hasMore,
  fetchData,
  onClickProfile,
  onClick,
}) => {
  const { isDesktop } = useDeviceType();
  
  const getNotificationMessage = (notification: TNotification) => {
    if (!notification.type) return '';

    const message: any = {
      [NOTIFICATION_TYPES.LIKE_POST]: `liked your article: ${(notification.article as TArticle)?.title}`,
      [NOTIFICATION_TYPES.COMMENT_POST]: `commented on your article: ${(notification.article as TArticle)?.title}`,
      [NOTIFICATION_TYPES.LIKE_COMMENT]: `liked your comment: ${(notification.comment as TComment)?.message}`,
      [NOTIFICATION_TYPES.REPLY_COMMENT]: `replied your comment: ${(notification.comment as TComment)?.message}`,
    };

    const senderUsername = (notification.sender as TUser).username;
    return `${senderUsername} ${message[notification.type]}`;
  };

  if (loading)
    return (
      <div className={styles.loading}>
        <WCircularProgress size={24} />
      </div>
    );

  return (
    <div className={styles.tabContainer}>
      {notifications.length ? (
        <InfiniteScroll
          dataLength={notifications.length}
          next={fetchData}
          hasMore={hasMore}
          loader={
            <div className={styles.loader}>
              <WCircularProgress  size={24} />
            </div>
          }
          height={isDesktop ? 464 : window.innerHeight - 148}
          className={styles.list}
        >
          {notifications.map((notification) => (
            <div
              key={notification._id}
              onClick={() => onClick(notification)}
              className={styles.item}
            >
              <ProfilePhoto
                user={notification.sender}
                width="32px"
                height="32px"
                radius="100%"
                onClick={(e) => {
                  e.stopPropagation();
                  onClickProfile((notification.sender as TUser)._id!);
                }}
              />
              <span className={`${styles.text} ${!notification.is_read && styles.unread}`}>
                {getNotificationMessage(notification)}
              </span>
            </div>
          ))}
        </InfiniteScroll>
      ) : (
        <WStack className={styles.noItem}>
          <WTypography>No notifications</WTypography>
          <WTypography>Notifications will show up here.</WTypography>
        </WStack>
      )}
    </div>
  );
};

export default NotificationTab;
